import Image from 'components/image'
import Slide, { Title } from '../../Slide/Slide'
import css from './PostInstallExtension.scss'
import Link from 'components/link'
import ExtensionPuzzlePiece from 'shared/svg/ExtensionPuzzlePiece.svg'

interface PostInstallExtensionProps {
  nextPath: string
}

interface StoreTile {
  name: string
  link: string
  imageUrl: string
}

const PostInstallExtension = (props: PostInstallExtensionProps) => {
  const { nextPath } = props

  const stores: StoreTile[] = [
    {
      name: 'Etsy',
      link: 'https://www.awin1.com/cread.php?awinmid=6220&awinaffid=228407&ued=https%3A%2F%2Fwww.etsy.com%2Fsearch%3Fq%3Dbaby+',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682665/Onboarding/Store%20Tile%20Logos/Etsy.png',
    },
    {
      name: 'Bloomingdales',
      link: 'https://click.linksynergy.com/deeplink?id=qsfL1JANoVU&mid=13867&murl=https://www.bloomingdales.com/shop/kids?id=3866&amp;cm_sp=NAVIGATION-_-TOP_NAV-_-KIDS-n-n',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682665/Onboarding/Store%20Tile%20Logos/Bloomingdales.png',
    },
    {
      name: 'Wayfair',
      link: 'https://www.kqzyfj.com/click-5004996-13720150?url=https%3A%2F%2Fwww.wayfair.com%2Fbaby-kids%2Fcat%2Fbaby-kids-c45226.html',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682666/Onboarding/Store%20Tile%20Logos/Wayfair.png',
    },
    {
      name: 'Nordstrom',
      link: 'https://click.linksynergy.com/deeplink?id=qsfL1JANoVU&mid=1237&murl=https://www.nordstrom.com/sr?origin=keywordsearch&amp;keyword=baby',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682667/Onboarding/Store%20Tile%20Logos/Nordstrom.png',
    },
    {
      name: "Macy's",
      link: 'https://www.kqzyfj.com/click-5004996-15590330?url=https%3A%2F%2Fwww.macys.com%2Fshop%2Fkids-clothes%3Fid%3D5991',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682667/Onboarding/Store%20Tile%20Logos/Macys.png',
    },
    {
      name: 'Crate&Kids',
      link: 'https://www.tkqlhce.com/click-5004996-13311537?url=https%3A%2F%2Fwww.crateandbarrel.com%2Fkids%2Fnursery-furniture%2F',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682668/Onboarding/Store%20Tile%20Logos/C_K.png',
    },
    {
      name: 'BabyGap',
      link: 'https://gap.igs4ds.net/vN6m9N',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682669/Onboarding/Store%20Tile%20Logos/Gap.png',
    },
    {
      name: 'Walmart',
      link: 'https://goto.walmart.com/c/65668/565706/9383?veh=aff&sourceid=imp_000011112222333344&u=https%3A%2F%2Fwww.walmart.com%2Fcp%2Fbaby-products%2F5427%3Fpovid%3Dbaby_flyout_allbaby_shopall',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682670/Onboarding/Store%20Tile%20Logos/Walmart.png',
    },
    {
      name: 'Target',
      link: 'https://goto.target.com/9WW9aY',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682670/Onboarding/Store%20Tile%20Logos/Target.png',
    },
    {
      name: 'Maisonette',
      link: 'https://maisonette.sjv.io/VyZba6',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682671/Onboarding/Store%20Tile%20Logos/Maisonette.png',
    },
    {
      name: 'Amazon',
      link: 'https://www.amazon.com/gp/browse.html?node=165796011&psc=1&th=1&linkCode=ll2&tag=blvisitor-20&linkId=9e8889dbfbb3d97da35b537603645e4e&language=en_US&ref_=as_li_ss_tl',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682672/Onboarding/Store%20Tile%20Logos/Amazon.png',
    },
    {
      name: 'H&M',
      link: 'https://www2.hm.com/en_us/baby/products/view-all.html',
      imageUrl:
        'https://images.babylist.com/image/upload/v1705682673/Onboarding/Store%20Tile%20Logos/H_M.png',
    },
  ]

  return (
    <Slide>
      <div className={css.PostInstallExtension__container}>
        <div className={css.PostInstallExtension__topSection}>
          <div className={css.PostInstallExtension__topTextContainer}>
            <Title className={css.PostInstallExtension__title}>
              Let the registry building begin!
            </Title>
            <p className={css.PostInstallExtension__subtext}>
              Now that you're set up, you can click the Babylist button anytime
              you want to add an item to your registry. Not seeing the button?
              Click the{' '}
              <ExtensionPuzzlePiece
                className={css.PostInstallExtension__subtextIcon}
              />{' '}
              in your browser toolbar to add it.
            </p>
          </div>

          <Image
            className={css.PostInstallExtension__exampleImage}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1705609703/Onboarding/Extension_image.png"
            width={464}
          />
        </div>

        <div className={css.PostInstallExtension__storeTileSection}>
          <h2 className={css.PostInstallExtension__storeTileHeader}>
            Get started by browsing from these popular stores:
          </h2>
          <div className={css.PostInstallExtension__storeTileContainer}>
            {stores.map(({ name, link, imageUrl }) => (
              <div className={css.PostInstallExtension__storeTile} key={name}>
                <Link
                  className={css.PostInstallExtension__storeTileLink}
                  url={link}
                  newWindow
                >
                  <Image
                    className={css.PostInstallExtension__storeTileImage}
                    src={imageUrl}
                  />
                </Link>
              </div>
            ))}
          </div>
        </div>

        <Link className={css.PostInstallExtension__registryLink} url={nextPath}>
          Take me to my registry home
        </Link>
      </div>
    </Slide>
  )
}

export default PostInstallExtension
